import db from "@/database";

export const findAll = () => db.potentialSpace.toArray();
